export function RequireLoginModal({ closeModal, heading, message, login }) {
  return (
    <div className="content-backdrop content-backdrop--show">
      <div className="content-backdrop__content">
        <div className="data-container py-5 px-3 px-lg-5 text-center">
          <h3 className="heading-h3 heading-lg-h2 mb-2">{heading}</h3>
          <p className="text-regular mb-3">{message}</p>
          <button
            type="button"
            onClick={login}
            className="button button--primary-blue mb-5"
          >
            Logga In
          </button>
          <p className="text-regular mb-4 px-lg-5">
            Saknar du ett Fotbollskonto?
            <br />{' '}
            <a
              className="text-color-primary-yellow"
              href="https://api.fotbollplay.se/allsvenskan/user/fotbollkonto/authorize?state=%2Fplaylist%2Faxk75b831a47r"
              target="_blank"
              rel="noreferrer"
            >
              Registrera dig gratis för att ta del av klipp från alla matcher
              och våra övriga tjänster.
            </a>
          </p>
          <p>
            <img
              width="150"
              src="/wp-content/themes/sef-leagues/images/fotbollskonto-logo.png"
              alt="Fotbollskonto"
            />
          </p>
        </div>
        <button
          type="button"
          onClick={closeModal}
          className="button content-backdrop__close"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
